import {
  ArrowDownRight,
  ArrowUpRight,
  CalendarDays,
  CircleDollarSign,
  WalletCards,
} from "lucide-react";

const icons = {
  today: WalletCards,
  month: CalendarDays,
  lifetime: CircleDollarSign,
};

function MetricCard({
  label,
  value,
  change,
  trend,
  helperText,
  icon = "today",
  variant = "default",
}) {
  const Icon = icons[icon] || WalletCards;

  return (
    <article
      className={[
        "metric-card",
        variant !== "default"
          ? `metric-card--${variant}`
          : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="metric-card__top">
        <span className="metric-card__icon">
          <Icon size={21} />
        </span>

        {change ? (
          <span
            className={[
              "metric-card__change",
              trend === "down"
                ? "metric-card__change--down"
                : "metric-card__change--up",
            ].join(" ")}
          >
            {trend === "down" ? (
              <ArrowDownRight size={15} />
            ) : (
              <ArrowUpRight size={15} />
            )}

            {change}
          </span>
        ) : null}
      </div>

      <div className="metric-card__content">
        <p className="metric-card__label">{label}</p>
        <strong className="metric-card__value">{value}</strong>
        <span className="metric-card__helper">{helperText}</span>
      </div>
    </article>
  );
}

export default MetricCard;